// import { Link, Outlet } from "react-router-dom";
// import {
//   Typography,
//   Container,
//   TextField,
//   Switch,
//   InputAdornment,
//   InputLabel,
//   FormControl,
//   OutlinedInput,
//   IconButton,
//   Box,
//   Toolbar,
//   AppBar,
//   Tabs,
//   Tab,
// } from "@mui/material";
// import React, { useState } from "react";
// import { IoIosArrowRoundBack } from "react-icons/io";
// import { FiChevronRight } from "react-icons/fi";
// import proifleimg from "../../assets/images/proifleimg.png";
// import carpark from "../../assets/images/car-parking.svg";
// import tabhome from "../../assets/images/tabhome.svg";
// import account from "../../assets/images/account.svg";
// import support from "../../assets/images/support.svg";
// import applepay from "../../assets/images/applepay.svg";
// import requestcall from "../../assets/images/requestcall.svg";
// import supportchat from "../../assets/images/supportchat.svg";
// import { FaCalendarAlt, FaParking, FaCreditCard, FaPencilAlt, FaTrash, FaPhoneAlt } from "react-icons/fa";
// import { AiOutlineInfoCircle } from "react-icons/ai";
// import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset, BsChatDots } from "react-icons/bs";
// import { Button, ButtonGroup, Card, Col, Form, Modal, Row } from "react-bootstrap";

// const Editprofile = () => {
//   const [phone, setPhone] = useState("");
//   const [date, setDate] = useState("");
//   const [time, setTime] = useState("");

//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   return (
//     <>
//       <Container>
//         <div className="app-container">
//           {/* Sticky Header */}
//           <header className="header text-white text-center d-flex justify-content-between align-items-center">
//             <Link to="/profile">
//               <button className="back-button backbutton">
//                 <IoIosArrowRoundBack size={30} color="white" />
//               </button>
//             </Link>
//             <div>Edit Profile</div>
//             <div className=" visablityhidden">
//               <button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button>{" "}
//             </div>
//           </header>
//           <Container className="mt-3 px-3 pagewrap">
//             {/* Phone Number Input */}
//             <div className="mb-3">
//               <label className="form-label">Name</label>
//               <input
//                 type="tel"
//                 className="form-control"
//                 placeholder="Enter Name"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value)}
//               />
//             </div>

//             <div className="mb-3">
//               <label className="form-label">Email</label>
//               <input
//                 type="tel"
//                 className="form-control"
//                 placeholder="Enter Email address"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value)}
//               />
//             </div>

//             <div className="mb-3">
//               <label className="form-label">Mobile Number</label>
//               <input
//                 type="tel"
//                 className="form-control"
//                 placeholder="Enter Phone Number"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value)}
//               />
//             </div>

//             <div className="mb-3">
//               <Link to="/profile">
//                 {" "}
//                 <Button className="btn btn-brand-1 w-100 font-bold" style={{ textTransform: "none" }}>
//                   Save
//                 </Button>
//               </Link>
//             </div>
//           </Container>
//         </div>
//       </Container>
//     </>
//   );
// };

// export default Editprofile;

import { Link, Outlet, useNavigate } from "react-router-dom";
import Loginimage from "../../assets/images/ezparklogo.png";
import {
  Button,
  Typography,
  Container,
  TextField,
  Switch,
  InputAdornment,
  InputLabel,
  FormControl,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Form } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useForm } from "react-hook-form";
import WebService from "../../Services/WebService";
import HelperService from "../../Services/HelperService";
import { toast } from "react-toastify";
import { IoIosArrowRoundBack } from "react-icons/io";

const Editprofile = () => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    watch,
    getValues,
    register,
    clearErrors,
    setValue,
    reset,
  } = useForm<any>({});

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const Navigate = useNavigate();
  const [StateList, setStateList] = useState([]);

  const [UserData, setUserData] = useState<any>({});

  useEffect(() => {
    const savedUserData = localStorage.getItem("user_data");
    const username = localStorage.getItem("username");
    if (savedUserData) {
      reset(JSON.parse(savedUserData));
      setValue("State", "TX");
      setValue("UserName", username);
      console.log("JSON.parse(savedUserData)", JSON.parse(savedUserData));
    }
  }, [StateList]);

  useEffect(() => {
    getVehicleStateList();
  }, []);

  const getVehicleStateList = () => {
    WebService.getAPI({
      action: `/api/Core/States`,
    })
      .then((res: any) => {
        setStateList(res);
      })
      .catch(() => {});
  };

  const onUpdate = (data: any) => {

    const newData ={
      "ID": data.MemberId,
      "EmailAddress":data.EmailAddress,
      "PhoneNumber": data.PhoneNumber,
      "FirstName":data.FirstName,
      "LastName":data.LastName,
      "UserName": data.UserName,
      "AddressLine1": data.AddressLine1,
      "AddressLine2": data.AddressLine2,
      "City":data.City,
      "State":data.State,
      "ZipCode":data.ZipCode,
      "MinBalance": data.MinBalance||"0",
  }
    WebService.postAPI({
      action: "/api/Account/Update",
      body: newData,
      id:"onUpdateBtn"
    }).then((res) => {
      Navigate("/profile");
      toast.success("User Updated");
    }).catch((e)=>{
      toast.error(e.response.data.Message);
    })
  };

  return (
    <>
      <Container>
        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            <Link to="/profile">
              <button className="back-button backbutton">
                <IoIosArrowRoundBack size={30} color="white" />
              </button>
            </Link>
            <div>Edit Profile</div>
            <div className=" visablityhidden">
              <button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button>{" "}
            </div>
          </header>

          <form onSubmit={handleSubmit(onUpdate)} className="text-start mt-4">
            {/* <Form.Group controlId="validationCustom01" className="mb-3">
              <Form.Label className="text-start d-block w-100 mb-2">First Name</Form.Label>
              <Form.Control {...register("FirstName")} type="text" placeholder="Enter FirstName" />
            </Form.Group>

            <Form.Group controlId="validationCustom01" className="mb-3">
              <Form.Label className="text-start d-block w-100 mb-2">Last Name</Form.Label>
              <Form.Control {...register("LastName")} type="text" placeholder="Enter LastName" />
            </Form.Group> */}

            <Form.Group className="mb-3">
              <Form.Label className="text-start d-block w-100 mb-2">Username</Form.Label>
              <Form.Control
                {...register("UserName", { required: "UserName is required" })}
                type="text"
                disabled
                placeholder="Enter Username"
              />
              {errors.UserName && (
                <Form.Text className="mt-4  text-danger">{"Username is Required"}</Form.Text>
              )}
            </Form.Group>

            {/* <div className="mb-3 position-relative passwordwrapper">
              <label className="form-label mb-2 text-start d-block w-100">Password</label>
              <div className="input-group">
                <input
                  {...register("password", { required: "Password is required" })}
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Password"
                  // value={password}
                  // onChange={(e) => {
                  //   setPassword(e.target.value); // Update local state
                  // }}

                  // onFocus={() => clearErrors("password")}
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {errors.password && <span className="text-danger">{"Password is Required"}</span>}
            </div> */}

            <Form.Group controlId="validationCustom01" className="mb-3">
              <Form.Label className="text-start d-block w-100 mb-2">Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Email"
                disabled
                {...register("EmailAddress", {
                  required: "Email is required", // Custom error message if empty
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email address", // Custom error message if invalid email format
                  },
                })}
                isInvalid={!!errors.EmailAddress} // Show error if email is invalid
              />
              {/* Error feedback message */}
              <Form.Control.Feedback type="invalid">
                {String(errors.EmailAddress?.message)}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="validationCustom01" className="mb-3">
              <Form.Label className="text-start d-block w-100 mb-2">Mobile Number</Form.Label>
              <Form.Control
                disabled
                {...register("PhoneNumber", { required: "PhoneNumber is required" })}
                type="text"
                onKeyPress={HelperService.allowOnlyNumericValue}
                placeholder="Enter Phone Number"
              />
              {errors.PhoneNumber && (
                <Form.Text className="mt-4  text-danger">{"PhoneNumber is Required"}</Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="text-start d-block w-100 mb-2">AddressLine 1</Form.Label>
              <Form.Control
                {...register("AddressLine1", { required: "AddressLine1 is required" })}
                type="text"
                placeholder="Enter AddressLine1"
              />
              {errors.AddressLine1 && (
                <Form.Text className="mt-4  text-danger">{"AddressLine1 is Required"}</Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="text-start d-block w-100 mb-2">City</Form.Label>
              <Form.Control
                {...register("City", { required: "City is required" })}
                type="text"
                placeholder="Enter City"
              />
              {errors.City && <Form.Text className="mt-4  text-danger">{"City is Required"}</Form.Text>}
            </Form.Group>

            <div className="mb-3">
              <Form.Label className="text-start d-block w-100 mb-2">State</Form.Label>
              <select
                className="form-select"
                id="exampleSelect"
                {...register("State", { required: "PlateNumber is required" })}
              >
                <option value="">Select State </option> {/* Default option */}
                {StateList.map((vehicle: any, index) => (
                  <option key={index} value={vehicle}>
                    {vehicle}
                  </option>
                ))}
              </select>
              {errors.State && <Form.Text className="mt-4  text-danger">{"State is Required"}</Form.Text>}
            </div>

            <Form.Group controlId="validationCustom01" className="mb-3">
              <Form.Label className="text-start d-block w-100 mb-2">ZipCode Code</Form.Label>
              <Form.Control
                {...register("ZipCode", { required: "ZipCode is required" })}
                type="text"
                placeholder="Enter ZipCode"
                onKeyPress={HelperService.allowOnlyNumericValue}
              />
              {errors.ZipCode && <Form.Text className="mt-4  text-danger">{"ZipCode is Required"}</Form.Text>}
            </Form.Group>

            {/* <div className="mb-3 position-relative passwordwrapper">
              <label className="form-label  mb-2 text-start d-block w-100">Password</label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <div className="mb-3 position-relative passwordwrapper">
              <label className="form-label  mb-2 text-start d-block w-100">Confirm Password</label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter Password Again"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div> */}

            {/* <Link to="/otp"> */}
            <div className="mb-3">
              {" "}
              <Button
                className="btn btn-brand-1 w-100 font-bold"
                type="submit"
                id="onUpdateBtn"
                style={{ textTransform: "none" }}
              >
                Ok
              </Button>
            </div>
            {/* </Link> */}
          </form>
        </div>
      </Container>
    </>
  );
};

export default Editprofile;
